import React, { Fragment, useState } from "react"
import { Dropdown, MenuItem } from "react-bootstrap"
import { TbDotsVertical } from "react-icons/tb"

import { haveAuth } from "utils"
import OfflineOrderDetailsPrintButton from "./OfflineOrderDetailsPrintButton"
import OfflineOrderDetailCancelButton from "./OfflineOrderDetailCancelButton"
import OfflineOrderDetailCancelModal from "./OfflineOrderDetailCancelModal"
import OfflineOrderDetailsCompleteButton from "../OfflineOrderDetailsCompleteButton"
import classes from "./index.module.scss"

const OfflineOrderDetailDropdown = props => {
  const {
    offlineOrder,
    setOfflineOrder
  } = props

  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const showCancelOrderTab =
    haveAuth(["cancelOrder"]) &&
    (
      offlineOrder.orderStatus === "paid" ||
      offlineOrder.orderStatus === "pending"
    )


  const showCompleteOrderTab =
    haveAuth(["completeOrder"]) &&
    offlineOrder.orderStatus === "paid"

  return (
    <Fragment>
      <div className={classes["container"]}>
        <Dropdown
          id="id"
          className={classes["dropdown"]}
        >
          <Dropdown.Toggle
            noCaret
            className={classes["dropdown-button"]}
          >
            <TbDotsVertical
              size={20}
            />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <MenuItem className={classes["item"]}>
              <OfflineOrderDetailsPrintButton
                offlineOrder={offlineOrder}
              />
            </MenuItem>

            {
              showCompleteOrderTab &&
              <MenuItem className={classes["item"]}>
                <OfflineOrderDetailsCompleteButton
                  offlineOrder={offlineOrder}
                  setOfflineOrder={setOfflineOrder}
                />
              </MenuItem>
            }

            {
              showCancelOrderTab &&
              <MenuItem className={classes["item"]}>
                <OfflineOrderDetailCancelButton
                  setShowConfirmationModal={setShowConfirmationModal}
                />
              </MenuItem>
            }
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <OfflineOrderDetailCancelModal
        offlineOrder={offlineOrder}
        setOfflineOrder={setOfflineOrder}
        showConfirmationModal={showConfirmationModal}
        setShowConfirmationModal={setShowConfirmationModal}
      />
    </Fragment>
  )
}

export default OfflineOrderDetailDropdown